var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallV2Ic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.46665 16.5313C2.86297 10.928 3.22284 6.59889 5.7833 4.67887L6.33502 4.26753C6.48111 4.15909 6.64751 4.08112 6.82432 4.03824C7.00113 3.99537 7.18476 3.98846 7.36429 4.01794C7.54382 4.04742 7.7156 4.11268 7.86943 4.20984C8.02325 4.30701 8.15599 4.43409 8.25975 4.58356L9.68544 6.63275C9.87673 6.90816 9.95938 7.24462 9.91748 7.57734C9.87558 7.91005 9.71208 8.2155 9.45848 8.43487L8.16947 9.55101C7.73437 9.92724 7.5839 10.5342 7.79205 11.0697C8.20834 12.1407 9.06726 13.3271 10.3688 14.6301C11.6704 15.9318 12.8565 16.7909 13.9274 17.2072C14.4628 17.4154 15.0709 17.2637 15.4471 16.8298L16.5631 15.5406C16.7824 15.2869 17.0878 15.1234 17.4205 15.0815C17.7532 15.0396 18.0896 15.1222 18.3649 15.3136L20.4163 16.7382C20.5657 16.8419 20.6927 16.9745 20.7899 17.1282C20.887 17.2819 20.9523 17.4536 20.9819 17.633C21.0115 17.8124 21.0047 17.9959 20.9621 18.1727C20.9194 18.3494 20.8417 18.5158 20.7335 18.662L20.321 19.2163C18.4 21.7784 14.0703 22.1358 8.4679 16.5325L8.46665 16.5313Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallV2Ic);
export default __webpack_public_path__ + "static/media/call_v2_ic.199f0c09.svg";
export { ForwardRef as ReactComponent };